import { useEffect, useState } from "react";

function canUseWebGL() {
  if (typeof document === "undefined") {
    return true;
  }

  const canvas = document.createElement("canvas");
  return Boolean(canvas.getContext("webgl") || canvas.getContext("experimental-webgl"));
}

export function useWebGLSupport() {
  const [supported, setSupported] = useState(true);

  useEffect(() => {
    setSupported(canUseWebGL());
  }, []);

  return supported;
}
